import React from 'react';
import { Box, Container, Typography, Grid } from '@mui/material';
import Footer from 'src/Component/Footer';
import Navbar from 'src/Component/Navbar';
import { useNavigate } from 'react-router';
import BackRouteContainer from 'src/Component/grid-component/BackButtonComponent';
import logo from '../../asset/backcourse.png'

const imageBaseUrl = process.env.REACT_APP_IMAGE_URL
const b1 = imageBaseUrl + 'selectcourse/b1.png'
const b2 = imageBaseUrl + 'selectcourse/b2.png'
const b3 = imageBaseUrl + 'selectcourse/b3.png'
const b4 = imageBaseUrl + 'selectcourse/b4.png'
const b5 = imageBaseUrl + 'selectcourse/b5.png'
const b6 = imageBaseUrl + 'selectcourse/b6.png'
const b7 = imageBaseUrl + 'selectcourse/b7.png'
const b8 = imageBaseUrl + 'selectcourse/b8.png'
const b9 = imageBaseUrl + 'selectcourse/b9.png'

// Sample data for universities
const universities = [
    { id: 1, name: 'Engineering', image: b1, path: "/study-abroad/courses/enginnering" },
    { id: 2, name: 'Computer Science & Information Technology', image: b2, path: "/study-abroad/courses/csit" },
    { id: 3, name: 'Health Science and Medicine', image: b3, path: "/study-abroad/courses/healthscience" },
    { id: 4, name: 'Social Science', image: b4, path: "/study-abroad/courses/socialscience" },
    { id: 5, name: 'Bussiness Management', image: b5, path: "/study-abroad/courses/bussinessmanagement" },
    { id: 6, name: 'Physical & Life Science', image: b6, path: "/study-abroad/courses/physicalscience" },
    { id: 7, name: 'Fine & Applied Art', image: b7, path: "/study-abroad/courses/fineart" },
    { id: 8, name: 'Communication & Journalism', image: b8, path: "/study-abroad/courses/journalism" },
    { id: 9, name: 'Designing', image: b9, path: "/study-abroad/courses/designing" },

];

const SelectCourses = () => {
    const navigate = useNavigate();
    return (
        <Box>
            <Navbar />
            <BackRouteContainer path={"/study-abroad"} title={"Study Abroad Main Page"} logo={logo} />
            <Container sx={{ padding: '40px' }}>
                <Grid container spacing={4}>
                    {universities?.map((university) => (
                        <Grid item key={university?.id} xs={12} sm={6} md={4} lg={4}>
                            <Box
                                sx={{
                                    height: { lg: '300px', xs: '300px', sm: "300px", md: "350px" },
                                    cursor: 'pointer',
                                    border: '1px solid #00999E',
                                    borderRadius: '10px',
                                    overflow: 'hidden',
                                    width: { lg: "350px", md: "320px", xs: "300px" },
                                    display: 'flex',
                                    boxShadow: 4,
                                    flexDirection: 'column'
                                }}
                                onClick={() => {
                                    navigate(university?.path);
                                }}
                            >
                                <img src={university?.image} alt={university?.name} width={'100%'} />
                                <Box
                                    sx={{
                                        display: 'flex',
                                        justifyContent: 'center',
                                        padding: '20px 10px'
                                    }}
                                >
                                    <Typography variant="h6" sx={{ fontWeight: '550', textAlign: "center" }}>
                                        {university?.name}
                                    </Typography>
                                </Box>
                            </Box>
                        </Grid>
                    ))}
                </Grid>
            </Container>
            <Box sx={{ mb: "20px" }}>

                <BackRouteContainer path={"/study-abroad"} title={"Study Abroad Main Page"} logo={logo} />
            </Box>

            <Footer />
        </Box>
    );
};

export default SelectCourses;
